import styled from 'astroturf/react'
import _Avatar from "Avatar.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/footer/avatar.js?styleId=Avatar";

const colorBackgroundTertiary = 'var(--colorBackgroundTertiary, var(--coreColorNeutral300))'
const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'

export const Avatar = /*#__PURE__*/styled('div', null, {
  displayName: "Avatar",
  styles: _Avatar
})
